<!-- 入力画面ダイアログ -->
<p-dialog [header]="title" [(visible)]="inputModal" [modal]="true">
  <!-- 入力情報 -->
  <app-generate-input-information
    (reloadID)="return($event)"
  ></app-generate-input-information>
</p-dialog>
